/* eslint-disable no-param-reassign */
import { getFileValidationRequiredFields } from '../../../helpers/revisionRequiredFields';
import validateFields from './validateFields';
import groupErrors from './groupErrors';

export default function setRequiredFieldErrors(state) {
  Object.values(state.items).forEach((files) => {
    files.forEach((file) => {
      const requiredFields = getFileValidationRequiredFields(file, state.requiredFields);
      const { isValid, errors, error } = validateFields({ fields: file.fields, requiredFields, importFrom: file.file?.importFrom });
      file.isValid = isValid;
      file.errors = isValid ? undefined : errors;
      file.error = isValid ? undefined : error;
    });
  });

  state.errors = groupErrors(Object.values(state.items).flat());
}
